<template>
    <component
            :is="selectedLayout"
            :subscription="mySubscriptionData"
            :configData="configData"
            @subscription-clicked="subscriptionClicked"
    >
    </component>
</template>

<script>
    import PreviewComponent from "./PreviewComponent";
    import SubscriptionPurchaseComponent
        from "../../components/pagesbuilder/dynamic-components/SubscriptionPurchaseComponent";
    import SubscriptionPurchaseLayout1 from "../../author/pagesbuilder/templates/cards/SubscriptionPurchaseLayout1";
    import SubscriptionPurchaseLayout2 from "../../author/pagesbuilder/templates/cards/SubscriptionPurchaseLayout2";

    export default {
        name: "PreviewSubscriptionPurchaseComponent",
        mixins: [
            PreviewComponent,
            SubscriptionPurchaseComponent
        ],
        methods: {
            subscriptionClicked (subscription) {
                window.location.href = `/payment?product_id=${subscription.titleId}&type=subscription`;
            }
        },
        components: {
            SubscriptionPurchaseLayout1,
            SubscriptionPurchaseLayout2
        }
    }
</script>

